export const MEMBER_LOGIN_TRIGGER = 'MEMBER_LOGIN_TRIGGER';
export const MEMBER_TOKEN_LOADED = 'MEMBER_TOKEN_LOADED';
export const MEMBER_LOGOUT_TRIGGER = 'MEMBER_LOGOUT_TRIGGER';
export const MEMBER_AUTH_REFRESH = 'MEMBER_AUTH_REFRESH';
export const MEMBER_AUTH_LOADED = 'MEMBER_AUTH_LOADED';
export const MEMBER_TOKEN_PRELOAD = 'MEMBER_TOKEN_PRELOAD';
export const MEMBER_STATUS_UPDATE_RECEIVED = 'MEMBER_STATUS_UPDATE_RECEIVED';
// OTP Actions
export const ASK_FOR_DATA = 'ASK_FOR_DATA';
export const CALL_CENTER = 'CALL_CENTER';
export const ASK_FOR_OTP = 'ASK_FOR_OTP';

export const loginTriggerAction = (token, account, isTemporary = false) => ({
  type: MEMBER_LOGIN_TRIGGER,
  payload: {
    token,
    account,
    isTemporary
  }
});
export const logoutTriggerAction = (token) => ({
  type: MEMBER_LOGOUT_TRIGGER,
  payload: {
    // token
  },
});

export const refreshAuthAction = () => ({
  type: MEMBER_AUTH_REFRESH
});

export const statusUpdateReceivedAction = (statusUpdate) => ({
  type: MEMBER_STATUS_UPDATE_RECEIVED,
  payload: statusUpdate
});

export const triggerActionCreator = (type, payload) => ({
  type: type,
  payload: payload
});



// WEBPACK FOOTER //
// ./src/modules/auth/AuthActions.js